// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__59qHq","buttons":"PendingPaymentAlert_buttons__3MbR-"};